import { render, staticRenderFns } from "./InfoMediaAvailable.vue?vue&type=template&id=6aef55bc&scoped=true"
import script from "./InfoMediaAvailable.vue?vue&type=script&lang=js"
export * from "./InfoMediaAvailable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aef55bc",
  null
  
)

export default component.exports